<template>
  <div class="vd-wrapper" @click="playVideo">
    <video ref="vd" :src="src" :controls="!isBtn" :poster="poster" webkit-playsinline playsinline x5-playsinline  preload="auto" id="video"></video>
    <div class="btn-play" v-show="isBtn"></div>
  </div>
</template>

<script>
export default {
  name: 'vdPlayer',
  data() {
    return {
      isBtn: true
    }
  },
  props: {
    src: String,
    poster: String
  },
  methods: {
    playVideo() {
      if (this.isBtn) {
        const vd = this.$refs.vd;
        vd.play();
        this.isBtn = false;
      }
    }
  },
  mounted() {
    const vd = this.$refs.vd;
    vd.addEventListener('pause', () => {
      this.isBtn = true;
    })
  }
}
</script>

<style lang="less" scoped>
.vd-wrapper {
  position: relative;
  width: 300px;
  height: 168px;
  overflow: hidden;
}
#video {
  width: 300px;
  height: 168px;
}
.btn-play {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 3.125rem /* 50/16 */;
  height: 3.125rem /* 50/16 */;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('./img/play.png');
  transform: translate(-50%, -50%);
}
</style>
